import isPropValid from '@emotion/is-prop-valid';

/**
 * Filter out props which should not be rendered to the DOM.
 *
 * Leverages isPropValid from emotion which checks a hard-coded list of
 * react-friendly keys, and any key with "onX".
 *
 * Prevents:
 * > Warning: React does not recognize the X prop on a DOM element...
 *
 * @example
 * ```tsx
 * <MyComponent {...filterProps(props)} />
 * ```
 */
export const filterProps = (props: unknown) =>
  // defensive: we expect an object, but TS wont accept `props: Record<string, unknown>`
  !props ||
  Array.isArray(props) ||
  ['string', 'number', 'boolean'].includes(typeof props)
    ? {}
    : Object.fromEntries(
        Object.entries(props as Record<string, unknown>).filter(([key, _]) =>
          isPropValid(key),
        ),
      );
